import { cn } from '../../lib/utils';
import React from 'react';

// Define the type for the icon prop
interface IconProps {
    text: string;
    className?: string;
    onClick?: () => void;
    className1?: string;
    icon: React.ComponentType<{ className?: string }>; // Accept any React component
}

const UnderlinePlusHeading = ({ text, className, onClick, icon: Icon, className1 }: IconProps) => {
    return (
        <div className={cn("border-b border-gray-300 text-primery-blue-900 pb-[5.5px] w-full flex gap-2 mb-4 items-center", className1)}>
            <button onClick={onClick} className="mb-1">
                <Icon className="w-5 h-5 rounded-full text-primery-blue-500" />
            </button>
            <h2
                className={cn(
                    'font-cairo leading-[33px] tracking-normal text-center md:text-[22px] sm:text-lg text-[16px] text-primery-blue-500 font-bold mb-2',
                    className,
                )}
            >
                {text}
            </h2>
        </div>
    );
};

export default UnderlinePlusHeading;
